import React, { useEffect, useState, useRef } from 'react';
import { Modal, message, Button } from 'antd';
import HTTP from '../../../script/service';
import { connect } from 'react-redux';
import './RiskCheckboxContent.scss';

const RiskCheckboxContent = ({ visible, onSuccess, onCancel, base }) => {
  const { uid, riskAuthData } = base;
  const timer = useRef(null);
  const [downTime, setDownTime] = useState(null);
  const [subType, setSubType] = useState(null); // 0: 读秒; 1: 答题; 2: 勾选
  const [checkLen, setCheckLen] = useState(0); // 选中的个数
  const [checked, setChecked] = useState(0); // 选中的个数
  const [confirmText, setConfirmText] = useState('申请解除限制');
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    setIsDisabled(checked !== checkLen || downTime > 0);
  }, [checkLen, checked, downTime]);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (!!visible) {
      let nextText = '申请解除限制';
      let count = riskAuthData.contentOptions
        ? riskAuthData.contentOptions.reduce(
            (c, n) => (c += n?.options?.length || 0),
            0
          )
        : 0;
      if (riskAuthData?.multiple) {
        nextText = '下一步';
        if (riskAuthData?.contentValid?.subType === 1) {
          // 答题
          nextText = '完成答题，并解除限制';
        }
      } else if (riskAuthData?.contentValid?.subType === 0) {
        // 弹窗
        setDownTime(riskAuthData.contentValid.viewSecond);
        count = 0;
      } else if (riskAuthData?.contentValid?.subType === 1) {
        // 答题
        nextText = '完成答题，并解除限制';
      }
      setSubType(riskAuthData?.contentValid?.subType ?? null);
      setChecked(0);
      setCheckLen(count);
      setIsDisabled(checked !== checkLen || downTime > 0);
      setConfirmText(nextText);
    } else {
      setSubType(null);
      setChecked(0);
      setCheckLen(0);
      setIsDisabled(false);
      setConfirmText('申请解除限制');
    }
  }, [visible]);

  useEffect(() => {
    if (downTime != null) {
      if (downTime <= 0) {
        clearTimeout(timer.current);
      } else {
        timer.current = setTimeout(() => {
          setDownTime(downTime - 1);
        }, 1000);
      }
    }
    return () => {
      clearTimeout(timer.current);
    };
  }, [downTime]);

  const handleConfirm = () => {
    if (subType === 0 || subType === 2) {
      if (downTime > 0) {
        message.warning('请等待');
        return;
      }
      if (isDisabled) {
        message.warning('请完善内容');
        return;
      }
      const params = {
        uid,
        sceneType: riskAuthData?.sceneType,
        requestTag: riskAuthData?.contentValid?.requestTag,
      };
      HTTP._relieve_risk_validate(params).then((res) => {
        if (res.code == 200) {
          onSuccess && onSuccess();
        } else {
          message.error(res.message || '操作失败，请稍后重试');
        }
      });
    } else {
      onSuccess && onSuccess();
    }
  };

  const onChangeCheck = (i, oi) => {
    riskAuthData.contentOptions[i].options[oi].checked =
      !riskAuthData.contentOptions[i].options[oi].checked;
    let checks = riskAuthData.contentOptions.reduce(
      (c, n) => (c += n?.options?.filter((e) => e.checked)?.length || 0),
      0
    );
    setChecked(checks);
  };

  const customText = (val) => {
    let text = val;
    if (val.indexOf('我确认充值') > -1 || val.indexOf('我确认消费') > -1) {
      text = val.replace(/\d/g, function (match) {
        return '<span style="color:#FF4279">' + match + '</span>';
      });
    }
    return text;
  };
  return (
    <Modal
      destroyOnHidden={true}
      footer={null}
      centered={true}
      open={visible}
      className="daidai-modal-style has-top-border risk-hint-container"
      width="560px"
      title={'风险提示'}
      onCancel={onCancel}
      maskClosable={false}
      zIndex={1009}
    >
      <div className="risk-hint-body">
        <div className="risk-hint-tip-icon" />
        <div className="risk-hint-form ">
          {!!riskAuthData?.contentOptions?.length &&
            riskAuthData.contentOptions.map((n, i) => (
              <div className="risk-hint-form-block" key={i}>
                <p className="risk-hint-tip-text">{n.viewContent}</p>
                {!!n.options?.length &&
                  n.options.map((op, oi) => (
                    <div
                      className="checkbox"
                      key={oi}
                      onClick={() => onChangeCheck(i, oi)}
                    >
                      <label>
                        <i
                          className={`icon-checkbox ${op.checked ? 'active' : ''}`}
                        ></i>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: customText(op.text),
                          }}
                        ></span>
                      </label>
                    </div>
                  ))}
              </div>
            ))}
          <div className="form-btns flex" style={{ marginTop: '24px' }}>
            <Button
              className={`daidai-btn-primary ${isDisabled ? 'disabled' : ''}`}
              disabled={isDisabled}
              onClick={() => handleConfirm()}
            >
              {confirmText}
              {downTime > 0 ? `(${downTime}s)` : null}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default connect((store) => ({ base: store }))(RiskCheckboxContent);
